module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0138.jpg?v=93257cc4";